<template>
  <Modal v-model="supplierWarehouseModal" :title="$t('key1002345')" width="800" class-name="commonModalStyles"
    :transfer="false" :mask-closable="false" @on-visible-change="supplierWarehouseChange">
    <div class="details_box_styles">
      <!--基础信息-->
      <div class="basic_information_box">
        <Card :bordered="false" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1002350') }}</h2>
          </template>
          <Row type="flex" :gutter="gutterItem">
            <Col :span="12" class="basic_item">
              <span class="basic_title">{{ $t('key1002327') }}</span>
              <span class="basic_txt" :title="warehouseName">{{ warehouseName }}</span>
            </Col>
            <Col :span="12" class="basic_item">
              <span class="basic_title">{{ $t('key1002351') }}</span>
              <span class="basic_txt">{{ warehouseForm.deliveryPlaceName }}</span>
            </Col>
            <Col :span="12" class="basic_item">
              <span class="basic_title">{{ $t('key1002352') }}</span>
              <span class="basic_txt">{{ warehouseCode }}</span>
            </Col>
          </Row>
        </Card>
      </div>
      <!--仓库配置-->
      <div class="basic_information_box">
        <Card :bordered="false" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1002353') }}</h2>
          </template>
          <!--仓库类型-->
          <div class="flex align-items-center mb30">
            <span>{{ $t('key1002354') }}</span>
            <CheckboxGroup v-model="warehouseTypes" class="flex align-items-center">
              <Checkbox label="isCollectionWarehouse">{{ $t('key1002114') }}</Checkbox>
              <Checkbox label="isDeliveryWarehouse">{{ $t('key1002115') }}</Checkbox>
            </CheckboxGroup>
          </div>
          <!--供货仓配置-->
          <Card :bordered="false" dis-hover v-if="warehouseTypes.includes('isCollectionWarehouse') && warehouseForm.ymsWarehouseCollectionSettings.length > 0">
            <template #title>
              <h2 class="title_box">{{ $t('key1002355') }}</h2>
            </template>
            <Row type="flex" :gutter="gutterItem">
              <Col :span="24" class="basic_item">
                <div class="flex align-items-start">
                  <Tooltip transfer :content="$t('key1002346')" max-width="400" placement="top">
                    <Icon color="#2D8CF0" type="md-alert" class="cursor mr3" size="17"/>
                  </Tooltip>
                  <span class="width_120 display-inline-block">{{ $t('key1002356') }}</span>
                  <span style="flex: 1;">{{ consolidationWarehouseData }}</span>
                </div>
              </Col>
              <Col :span="24" class="basic_item">
                <span class="basic_title">{{ $t('key1002357') }}</span>
                <RadioGroup v-model="isProportion">
                  <Radio :disabled="true" :label="1">{{ $t('key1000392') }}</Radio>
                  <Radio :disabled="true" :label="0">{{ $t('key1000393') }}</Radio>
                </RadioGroup>
              </Col>
            </Row>
          </Card>
          <!--直发仓配置-->
          <Card :bordered="false" dis-hover v-if="warehouseTypes.includes('isDeliveryWarehouse')">
            <template #title>
              <h2 class="title_box">{{ $t('key1002358') }}</h2>
            </template>
            <Row type="flex" :gutter="gutterItem" class="mb24">
              <Col :span="12">
                <div class="flex align-items-center">
                  <Tooltip :content="$t('key1002347')"
                    transfer max-width="400" placement="top">
                    <Icon color="#2D8CF0" type="md-alert" class="cursor mr3" size="17"/>
                  </Tooltip>
                  <span class="basic_title red-dot">{{ $t('key1002359') }}</span>
                  <div class="validate-input-wrap" :class="{'validate-input-error': aliasWarehouseNameError}">
                    <Input v-model.trim="aliasWarehouseName" class="width_170" :placeholder="$t('key1002343')"
                      @on-blur="validateAliasField('aliasWarehouseName')"></Input>
                    <div class="validate-error-message" v-if="aliasWarehouseNameError">{{ $t('key1002360') }}</div>
                  </div>
                </div>
              </Col>
              <Col :span="12">
                <div class="flex align-items-center">
                  <span class="basic_title red-dot">{{ $t('key1002361') }}</span>
                  <div class="validate-input-wrap" :class="{'validate-input-error': aliasWarehouseCoreError}">
                    <Input v-model.trim="aliasWarehouseCore" class="width_160" :placeholder="$t('key1002344')"
                      @on-blur="validateAliasField('aliasWarehouseCore')"></Input>
                    <div class="validate-error-message" v-if="aliasWarehouseCoreError">{{ $t('key1002362') }}</div>
                  </div>
                </div>
              </Col>
            </Row>
            <template v-if="warehouseForm.ymsWarehouseDeliverySettings.length > 0">
              <div class="flex align-items-center mb10">
                <Tooltip transfer :content="$t('key1002348')" max-width="400" placement="top">
                  <Icon color="#2D8CF0" type="md-alert" class="cursor mr3" size="17"/>
                </Tooltip>
                <span class="basic_title red-dot">{{ $t('key1002363') }}</span>
              </div>
              <Tabs v-model="logisticsType" :animated="false" @on-click="changeTab">
                <TabPane :label="$t('key1001587')" name="selfOwnedLogistics"></TabPane>
                <TabPane :label="$t('key1002349')" name="thirdPartyLogistics"></TabPane>
              </Tabs>
              <!--自有物流-->
              <template v-if="logisticsType === 'selfOwnedLogistics'">
                <Tabs type="card" :animated="false" v-model="logisticsChannelsType">
                  <TabPane v-for="(item,index) in selfOwnedLogisticsData" :label="item.carrierName" :name="item.type + '_' + index">
                    <Tag class="mb10 mr25" v-for="ele in item.carrierShippingMethods">{{ ele.carrierShippingMethodName }}</Tag>
                  </TabPane>
                </Tabs>
              </template>
              <!--第三方物流-->
              <template v-if="logisticsType === 'thirdPartyLogistics'">
                <Tabs type="card" :animated="false" v-model="logisticsChannelsType">
                  <TabPane v-for="(item,index) in thirdPartyLogisticsData" :label="item.carrierName" :name="item.type + '_' + index">
                    <Tag class="mb10 mr25" v-for="ele in item.carrierShippingMethods">{{ ele.carrierShippingMethodName }}</Tag>
                  </TabPane>
                </Tabs>
              </template>
            </template>
          </Card>
        </Card>
      </div>
      <!--仓库地址-->
      <div class="basic_information_box">
        <Card :bordered="false" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1002364') }}</h2>
          </template>
          <Row type="flex" :gutter="gutterItem">
            <!--发货地址-->
            <h3 class="color-333 pl20 font-size-13">{{ $t('key1002365') }}</h3>
            <Divider style="margin: 5px 0 15px 0"/>
            <Row type="flex" :gutter="gutterItem" class="basic_information_box pl62 font-size-12" v-if="Object.keys(addressDetails).length >0">
              <Col :span="12" class="basic_item" v-for="ele in addressInfoList" style="line-height: initial;">
                <span class="basic_title">{{ ele.title + '：' }}</span>
                <span class="basic_txt" :title="addressDetails[ele.paramsKey]">{{ addressDetails[ele.paramsKey] || '--' }}</span>
              </Col>
            </Row>
            <!--退货地址-->
            <h3 class="color-333 mt30 pl20 font-size-13">{{ $t('key1002366') }}</h3>
            <Divider style="margin: 5px 0 15px 0"/>
            <!--退货地址详情-->
            <Row type="flex" :gutter="gutterItem" class="basic_information_box pl62 font-size-12" v-if="Object.keys(returnAddressDetails).length >0">
              <Col :span="12" class="basic_item" v-for="ele in addressInfoList">
                <span class="basic_title">{{ ele.title + '：' }}</span>
                <span class="basic_txt" :title="returnAddressDetails[ele.paramsKey]">{{ returnAddressDetails[ele.paramsKey] || '--' }}</span>
              </Col>
            </Row>
          </Row>
        </Card>
      </div>
    </div>
    <template #footer>
      <Button @click="supplierWarehouseModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="supplierWarehouseBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getAllYmsWarehouseData, isJSON} from "@/utils/common";

export default {
  name: 'supplierWarehouseModal',
  mixins: [Mixin],
  props: {
    countrysOriginalData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      supplierWarehouseModal: false,
      warehouseTypes: [],
      isProportion: 0,
      warehouseForm: {},
      addressDetails: {},
      returnAddressDetails: {},
      logisticsType: 'selfOwnedLogistics',
      logisticsChannelsType: 'selfOwnedLogistics_0',
      addressInfoList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002331'), paramsKey: 'name'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002332'), paramsKey: 'countryCodeName'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002333'), paramsKey: 'state'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002334'), paramsKey: 'city'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002335'), paramsKey: 'district'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002336'), paramsKey: 'street'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002337'), paramsKey: 'street2'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002338'), paramsKey: 'street3'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002339'), paramsKey: 'phone'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002340'), paramsKey: 'postcode'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002341'), paramsKey: 'company'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'), paramsKey: 'email'},
      ],
      ymsWarehouseId: null,
      selfOwnedLogisticsData: [],
      thirdPartyLogisticsData: [],
      consolidationWarehouseData: [],
      ymsWarehouseData: [],
      aliasWarehouseName: '',
      aliasWarehouseCore: '',
      aliasWarehouseNameError: false,
      aliasWarehouseCoreError: false,
    }
  },
  computed: {
    warehouseName() {
      return this.warehouseForm.name;
    },
    warehouseCode() {
      return this.warehouseForm.code;
    },
  },
  methods: {
    // 初始化数据
    initSupplierWarehouseData(obj) {
      let {ymsWarehouseId} = obj;
      getAllYmsWarehouseData().then((data) => {
        this.ymsWarehouseData = data;
        this.getLogisticsDataEnabledAllData(ymsWarehouseId, obj);
        this.supplierWarehouseModal = true;
      });
    },
    // 获取仓库详情
    getWarehouseDetails(ymsWarehouseId, obj) {
      this.ymsWarehouseId = ymsWarehouseId;
      this.axios.get(api.get_ymsWarehouse + ymsWarehouseId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            this.warehouseForm = {...data, deliveryPlaceName: obj.deliveryPlaceName};
            // 仓库类型
            this.warehouseTypes = [
              ...(data.isCollectionWarehouse === 1 ? ['isCollectionWarehouse'] : []),
              ...(data.isDeliveryWarehouse === 1 ? ['isDeliveryWarehouse'] : [])
            ];
            // 对外展示字段
            this.aliasWarehouseName = data.aliasWarehouseName || '';
            this.aliasWarehouseCore = data.aliasWarehouseCore || '';
            // 仓库地址
            const ymsWarehouseAddress = data.ymsWarehouseAddress ?? [];
            if (Array.isArray(ymsWarehouseAddress) && ymsWarehouseAddress.length > 0) {
              let sender = null;
              let returnAddr = null;
              ymsWarehouseAddress.forEach(item => {
                if (item.addressType === 'sender') {
                  sender = item;
                } else if (item.addressType === 'return') {
                  returnAddr = item;
                }
              });
              this.addressDetails = sender || {};
              this.returnAddressDetails = returnAddr || {};

              // 匹配国家
              const senderCountry = sender ? this.countrysOriginalData.find(c => c.twoCode === sender.countryCode) : null;
              const returnCountry = returnAddr ? this.countrysOriginalData.find(c => c.twoCode === returnAddr.countryCode) : null;
              if (senderCountry) {
                this.addressDetails.countryCodeName = senderCountry.cnName;
              }
              if (returnCountry) {
                this.returnAddressDetails.countryCodeName = returnCountry.cnName;
              }
            }
            // 供货仓配置
            let ymsWarehouseCollectionSettings = data.ymsWarehouseCollectionSettings || [];
            let consolidationWarehouseList = [];
            if (ymsWarehouseCollectionSettings.length > 0) {
              ymsWarehouseCollectionSettings.map((item) => {
                this.ymsWarehouseData.map((ele) => {
                  if (item.targetYmsWarehouseId === ele.ymsWarehouseId) {
                    consolidationWarehouseList.push(ele.name);
                  }
                })
              })
            }
            this.consolidationWarehouseData = consolidationWarehouseList.join('、');
            let ymsWarehouseDeliverySettingList = data.ymsWarehouseDeliverySettings || [];
            if (ymsWarehouseDeliverySettingList.length > 0) {
              const settingMap = ymsWarehouseDeliverySettingList.reduce((map, setting) => {
                const key = `${setting.carrierType}_${setting.carrierId}_${setting.carrierShippingMethodId}`;
                map[key] = true;
                return map;
              }, {});
              const filterCarrierData = (carrierData, carrierType) => {
                return carrierData.map(carrier => {
                  const methods = carrier.carrierShippingMethods || [];
                  const filteredMethods = methods.filter(method => settingMap[`${carrierType}_${carrier.carrierId}_${method.shippingMethodId}`]);
                  return {
                    ...carrier,
                    carrierShippingMethods: filteredMethods
                  };
                }).filter(carrier => carrier.carrierShippingMethods.length > 0);
              };
              // 过滤自有物流和第三方物流
              this.selfOwnedLogisticsData = filterCarrierData(this.selfOwnedLogisticsData, 1);
              this.thirdPartyLogisticsData = filterCarrierData(this.thirdPartyLogisticsData, 2);
            }
          }
        }
      });
    },
    // 切换物流方式
    changeTab(name) {
      this.logisticsType = name;
      let data = name === 'selfOwnedLogistics' ? this.selfOwnedLogisticsData : this.thirdPartyLogisticsData;
      if (data.length > 0) {
        this.logisticsChannelsType = data[0].type + '_0';
      }
      // 强制更新以确保 CheckboxGroup 正确渲染
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    // 校验对外展示字段（失焦触发）
    validateAliasField(fieldName) {
      if (fieldName === 'aliasWarehouseName') {
        this.aliasWarehouseNameError = !this.aliasWarehouseName;
      } else if (fieldName === 'aliasWarehouseCore') {
        this.aliasWarehouseCoreError = !this.aliasWarehouseCore;
      }
    },
    // 确定按钮
    supplierWarehouseBtn() {
      // 直发仓时校验对外展示字段
      if (this.warehouseTypes.includes('isDeliveryWarehouse')) {
        this.aliasWarehouseNameError = !this.aliasWarehouseName;
        this.aliasWarehouseCoreError = !this.aliasWarehouseCore;
        if (this.aliasWarehouseNameError) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002343'));
          return false;
        }
        if (this.aliasWarehouseCoreError) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002344'));
          return false;
        }
      }
      let query = {
        warehouseId: this.ymsWarehouseId,
        isCollectionWarehouse: this.warehouseTypes.includes('isCollectionWarehouse') ? 1 : 0,
        isDeliveryWarehouse: this.warehouseTypes.includes('isDeliveryWarehouse') ? 1 : 0,
        aliasWarehouseName: this.aliasWarehouseName,
        aliasWarehouseCore: this.aliasWarehouseCore,
      };
      this.axios.put(api.put_ymsWarehouse_updateSupplierSetting, query,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
          this.$emit('updateData', true);
          this.supplierWarehouseModal = false;
        }
      });
    },
    // 监听弹窗
    supplierWarehouseChange(value) {
      if (!value) {
        this.addressDetails = {};
        this.warehouseForm = {};
        this.warehouseTypes = [];
        this.selfOwnedLogisticsData = [];
        this.thirdPartyLogisticsData = [];
        this.logisticsType = 'selfOwnedLogistics';
        this.logisticsChannelsType = 'selfOwnedLogistics_0';
        this.aliasWarehouseName = '';
        this.aliasWarehouseCore = '';
        this.aliasWarehouseNameError = false;
        this.aliasWarehouseCoreError = false;
      }
    },
    // 获取自有、第三方物流的数据
    async getLogisticsDataEnabledAllData(ymsWarehouseId, obj) {
      const fetchLogisticsData = async (url, query) => {
        try {
          const response = await this.axios.post(url, query);
          if (response.data.code === 0) {
            return response.data.datas || [];
          }
          return [];
        } catch (error) {
          return [];
        }
      };
      const [selfOwnedLogisticsData, thirdPartyLogisticsData] = await Promise.all([
        fetchLogisticsData(api.post_ymsSupplierCarrier_api_queryForOwnCarriersList,
          {
            isFilter: true,
            status: 1,
            merchantId: obj.supplierMerchantId
          }),
        fetchLogisticsData(api.post_ymsCarrier_query, {
          carrierIds: [],
          carrierName: '',
          status: 1
        })
      ]);
      const handleData = (data, type) => data.map(item => ({type, ...item}));
      const hanleName = (data) => {
        data.map((item) => {
          const carrierShippingMethodsList = (item.carrierShippingMethods || []).filter(method => method.status === 1);
          item.carrierShippingMethods = carrierShippingMethodsList;
          carrierShippingMethodsList.map((ele) => {
            let name = ele.carrierShippingMethodName;
            if (isJSON(name)) {
              let obj = JSON.parse(name);
              ele.carrierShippingMethodName = obj[this.languagesVal];
            }
          });
        });
        return data;
      }
      this.selfOwnedLogisticsData = handleData(hanleName(selfOwnedLogisticsData), 'selfOwnedLogistics');
      this.thirdPartyLogisticsData = handleData(hanleName(thirdPartyLogisticsData), 'thirdPartyLogistics');
      this.getWarehouseDetails(ymsWarehouseId, obj);
      this.$forceUpdate();
    },
  }
};
</script>

<style lang="less">
.commonModalStyles /deep/ {
  .details_box_styles {
    .ivu-card-head {
      padding: 0 0 10px 0;
    }

    .title_box {
      font-size: 14px;
    }
  }

  .ivu-checkbox-wrapper {
    margin-right: 40px;
  }

  .basic_txt {
    max-width: 260px !important;
  }

  .validate-input-wrap {
    display: inline-block;
    position: relative;

    &.validate-input-error {
      .ivu-input {
        border-color: #ed4014;
      }
    }

    .validate-error-message {
      position: absolute;
      left: 0;
      bottom: -18px;
      color: #ed4014;
      font-size: 12px;
      line-height: 1;
      padding-top: 4px;
    }
  }
}
</style>
